module.exports = __webpack_public_path__ + "img/video.6d979250.png";